export default __webpack_public_path__ + "static/media/coinflipper.5613ddfa.PNG";